module.exports = __webpack_public_path__ + "img/YXC.0a58058d.jpg";